import _functionCall from "../internals/function-call";
import _getBuiltIn from "../internals/get-built-in";
import _wellKnownSymbol from "../internals/well-known-symbol";
import _defineBuiltIn from "../internals/define-built-in";
var exports = {};
var call = _functionCall;
var getBuiltIn = _getBuiltIn;
var wellKnownSymbol = _wellKnownSymbol;
var defineBuiltIn = _defineBuiltIn;
exports = function () {
  var Symbol = getBuiltIn("Symbol");
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, {
      arity: 1
    });
  }
};
export default exports;